import React, { useContext, useEffect } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "../../css/footerUsa.css";
import { ActualLangContext } from "../../contexts/ActualLangContext";
import SocialLinks from "./SocialLinks";

const LEGACY_FOOTER_DESCRIPTOR =
  "Possumus: Microsoft Solutions Partner. Software engineering, cloud engineering, staff augmentation and ITaaS. Agile, innovation and human value.";
const UPDATED_FOOTER_DESCRIPTOR =
  "Possumus: Microsoft Solutions Partner. AI-augmented software, cloud, data, and nearshore engineering teams for organizations across the Americas.";

const normalizeFooterText = (text, lang) => {
  if (lang === "en" && text === LEGACY_FOOTER_DESCRIPTOR) {
    return UPDATED_FOOTER_DESCRIPTOR;
  }
  return text;
};

const FooterUsaDesk = ({ logoPossumus, logoIso, options }) => {
  let newDate = new Date();
  let year = newDate.getFullYear();
  const { actualLang } = useContext(ActualLangContext);

  useEffect(() => {
    if (window.CLUTCHCO && window.CLUTCHCO.Init) {
      window.CLUTCHCO.Init();
    }
  }, []);
  return (
    <Container fluid id="footer">
      <Container>
        <Row className="footer-nav-row">
          {options?.map((option, idx) => {
            return (
              <Col key={idx} className="footer-nav-col">
                <p className="titleFooter">
                  {normalizeFooterText(option.title, actualLang)}
                </p>
                {option.multipleOptions.data?.length > 0 &&
                  option.multipleOptions.data.map((multipleOption, index) => (
                    <p key={index}>
                      <a
                        href={
                          multipleOption.attributes.href.includes("https") ||
                          multipleOption.attributes.href.includes("#") ||
                          multipleOption.attributes.href === "/solutions" ||
                          multipleOption.attributes.href === "/soluciones"
                            ? multipleOption.attributes.href
                            : `/${actualLang === "en" ? "en-en" : "es-es"}${
                                multipleOption.attributes.href
                              }`
                        }
                      >
                        {normalizeFooterText(
                          multipleOption.attributes.title,
                          actualLang
                        )}
                      </a>
                    </p>
                  ))}
              </Col>
            );
          })}
        </Row>
        
        <Row className="footer-logos-row">
          <Col className="d-flex justify-content-center align-items-center">
            <div className="footer-logos-container">
              <a href="/" className="footer-logo-item">
                <Image src={logoPossumus} alt="Possumus" fluid />
              </a>
              <div className="footer-logo-item clutch-container">
                <div
                  id="clutch-widget-footer"
                  className="clutch-widget"
                  data-url="https://widget.clutch.co"
                  data-widget-type="2"
                  data-height="45"
                  data-nofollow="true"
                  data-expandifr="true"
                  data-primary-color="#fcd702"
                  data-secondary-color="#fcd702"
                  data-clutchcompany-id="1572791"
                ></div>
              </div>
              <div className="footer-logo-item">
                <Image src={logoIso} alt="ISO Certification" fluid />
              </div>
            </div>
          </Col>
        </Row>
        
        
        {/* FILA 3: Copyright y redes sociales */}
        <Row className="footer-bottom-row">
          <Col md={6} className="footer-copyright">
            <p>Copyright © {year} Possumus. All Rights Reserved.</p>
          </Col>
          <Col md={6} className="footer-social">
            <SocialLinks title="Join Us" />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default FooterUsaDesk;
